module.exports = __webpack_public_path__ + "static/media/photo148.2241d24e.jpg";